import Div100vh from "react-div-100vh";
import { ReactSVG } from "react-svg";
import wlhLogo from "../../../../assets/images/layout/wlh-header-logo.svg";
import rightCloud from "../../../../assets/images/layout/right-cloud.svg";
import poppetje from "../../../../assets/images/error/error-screens-mobile-popetjee.svg";

const MobileErrorPage = ({ navigateHome }) => {
    return (
        <Div100vh>
            <div className="h-full w-full relative navy-blue-scrollbar">
                <ReactSVG src={rightCloud} className="absolute right-0 -top-8 opacity-50 z-[-1]" />
                <div className="h-full py-[29px] flex justify-center">
                    <div className="flex flex-col items-center justify-between">
                        <ReactSVG src={wlhLogo} />
                        <div className="text-5xl text-center font-bold text-standart-ocean">
                            Something's <br /> not right
                        </div>
                        <ReactSVG src={poppetje} />
                        {/* Hiding this temporarily */}
                        {/* <button onClick={() => navigateHome()} className="w-1/2 rounded bg-standart-ocean px-5 py-3 text-sm font-medium text-white hover:bg-light-purple active:text-black">
                            Go Back Home
                        </button> */}
                    </div>
                </div>
            </div>
        </Div100vh>
    )
}

export default MobileErrorPage;